import { Pipe, PipeTransform } from '@angular/core';
import { SEMANAS } from 'app/domains/shared/constants/semanas';

@Pipe({
  name: 'periodicidadeCompraSemana',
})
export class PeriodicidadeCompraSemanaPipe implements PipeTransform {
  transform(value: number): string {
    if (!value) {
      return '';
    }

    const index = SEMANAS.findIndex((semana) => semana.id === value);
    if (index > -1) {
      return SEMANAS[index].nome;
    }
    return '';
  }
}
